import { defineMessages } from 'react-intl';

const messages = defineMessages({
  recommended: {
    id: 'hubs.events.row.recommended',
    defaultMessage: 'Recommended for you!',
  },
  recommendedMobile: {
    id: 'hubs.events.row.recommended.mobile',
    defaultMessage: 'Recommended',
  },
  signup: {
    id: 'hubs.events.row.signup',
    defaultMessage: 'SIGN UP',
  },
  moredetails: {
    id: 'hubs.events.row.more.details',
    defaultMessage: 'View more details',
  },
  fewerdetails: {
    id: 'hubs.events.row.fewer.details',
    defaultMessage: 'View fewer details',
  },
  nodetails: {
    id: 'hubs.events.row.node.details',
    defaultMessage: 'No additional details available',
  },
  virtualEvent: {
    id: 'hubs.events.row.virtual.event',
    defaultMessage: 'Virtual Event',
  },
  coppaBlockText: {
    id: 'hubs.events.coppaBlockText',
    defaultMessage: `It looks like you won't be able to sign up for this event through Naviance because there is a COPPA block on your account.`,
  },
  ferpaBlockText: {
    id: 'hubs.events.ferpaBlockText',
    defaultMessage: `It looks like you won't be able to sign up for this event through Naviance because there is a FERPA block on your account.`,
  },
  coppaFerpaBlockHint: {
    id: 'hubs.events.coppaFerpaBlockText',
    defaultMessage: 'Please contact your counselor for assistance.',
  },
});

export default messages;
